import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../includes/myStyles.css";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import NavBar_appID from "./layout/NavBar_appID";
import { getUserInfo, setToken, setUserInfo } from "../utility/Common";
import { createNotification } from "./Popup";
import { photoUpload } from "../utility/services/apiService";
//import CentryReusableComponent from "./CentryReusableComponent";

const UploadPhotoComponent = () => {
  let navigate = useNavigate();
  let userInfo = getUserInfo();
  const [isloading, setIsloading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileError, setFileError] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  // const { checkApplicationStage } = CentryReusableComponent({});

  useEffect(() => {
    // checkApplicationStage(2);
    //loadExistingPhoto();
  }, []);

  const validateFile = (file) => {
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      setFileError("Picha lazima iwe PNG, JPG au JPEG");
      return false;
    }

    if (file.size > maxSize) {
      setFileError("Ukubwa wa picha lazima usiwe zaidi ya 5MB");
      return false;
    }

    setFileError("");
    return true;
  };

  const validateImageDimensions = (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target.result;
        img.onload = () => {
          const isWidthValid = img.width >= 120 && img.width <= 500;
          const isHeightValid = img.height >= 120 && img.height <= 500;

          if (isWidthValid && isHeightValid) {
            resolve({ valid: true, url: e.target.result, img: img });
          } else {
            let errorMsg = `Ukubwa wa picha yako ni ${img.width}px x ${img.height}px. `;
            if (!isWidthValid) {
              errorMsg += `Upana lazima uwe kati ya 120px na 500px. `;
            }
            if (!isHeightValid) {
              errorMsg += `Urefu lazima uwe kati ya 120px na 500px.`;
            }
            setFileError(errorMsg);
            resolve({ valid: false, url: null, img: null });
          }
        };
      };

      reader.readAsDataURL(file);
    });
  };

  const removeBackground = (img) => {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;

      // Fill canvas with white background
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw the image
      ctx.drawImage(img, 0, 0);

      // Get image data
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // Process pixels - remove background (make transparent pixels and near-white pixels white)
      for (let i = 0; i < data.length; i += 4) {
        const red = data[i];
        const green = data[i + 1];
        const blue = data[i + 2];
        const alpha = data[i + 3];

        // If pixel is very light (potential background) or transparent, make it white
        const brightness = (red + green + blue) / 3;
        if (brightness > 240 || alpha < 128) {
          data[i] = 255; // R
          data[i + 1] = 255; // G
          data[i + 2] = 255; // B
          data[i + 3] = 255; // A
        }
      }

      // Put the processed image data back
      ctx.putImageData(imageData, 0, 0);

      // Convert canvas to blob as JPEG
      canvas.toBlob(
        (blob) => {
          const url = URL.createObjectURL(blob);
          resolve({ blob, url });
        },
        "image/jpeg",
        0.95,
      );
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file && validateFile(file)) {
      const dimensionCheck = await validateImageDimensions(file);
      if (dimensionCheck.valid) {
        // Remove background and make it white
        const processed = await removeBackground(dimensionCheck.img);

        // Create a new file from the blob as JPEG
        const fileName = file.name.replace(/\.(png|jpeg|jpg)$/i, ".jpg");
        const processedFile = new File([processed.blob], fileName, {
          type: "image/jpeg",
          lastModified: Date.now(),
        });

        setSelectedFile(processedFile);
        setPreviewUrl(processed.url);
        setIsButtonDisabled(false);
      } else {
        setSelectedFile(null);
        setPreviewUrl(null);
        setIsButtonDisabled(true);
      }
    } else {
      setSelectedFile(null);
      setPreviewUrl(null);
      setIsButtonDisabled(true);
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && validateFile(file)) {
      const dimensionCheck = await validateImageDimensions(file);
      if (dimensionCheck.valid) {
        // Remove background and make it white
        const processed = await removeBackground(dimensionCheck.img);

        // Create a new file from the blob as JPEG
        const fileName = file.name.replace(/\.(png|jpeg|jpg)$/i, ".jpg");
        const processedFile = new File([processed.blob], fileName, {
          type: "image/jpeg",
          lastModified: Date.now(),
        });

        setSelectedFile(processedFile);
        setPreviewUrl(processed.url);
        setIsButtonDisabled(false);
      } else {
        setSelectedFile(null);
        setPreviewUrl(null);
        setIsButtonDisabled(true);
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const removePhoto = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
    setFileError("");
    setIsButtonDisabled(true);
  };

  // const loadExistingPhoto = async () => {
  //   setIsloading(true);
  //   const payload = {
  //     DocTypeId: "",
  //     Type: "",
  //     ApplicationId: getAppId(),
  //     EmailAddress: getEmail(),
  //     Action: "SelectPhoto",
  //   };

  //   try {
  //     const result = await applicationManagementMasilingi(
  //       payload,
  //       "add-attachment-info",
  //     );
  //     if (result.code == 1 && result.data && result.data[0]?.PhotoUrl) {
  //       setPreviewUrl(result.data[0].PhotoUrl);
  //       setIsButtonDisabled(false);
  //     }
  //   } catch (error) {
  //     console.log("No existing photo found");
  //   } finally {
  //     setIsloading(false);
  //   }
  // };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          // Create canvas and convert to JPEG format
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          // Convert to JPEG Base64 (will start with "/9j/")
          const jpegDataURL = canvas.toDataURL("image/jpeg", 0.95);
          // Remove the data:image/jpeg;base64, prefix
          const base64String = jpegDataURL.split(",")[1];
          resolve(base64String);
        };
        img.onerror = (error) => reject(error);
        img.src = reader.result;
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const uploadPhoto = async () => {
    let documentNo = userInfo?.DocumentNumber || "";
    console.log("Document Number for upload:", documentNo);
    if (!selectedFile && !previewUrl) {
      createNotification({
        type: "error",
        message: "Tafadhali chagua picha",
      })();
      return;
    }

    setIsloading(true);

    try {
      // Convert image to Base64
      const base64Photo = await convertToBase64(selectedFile);

      // Prepare payload according to API specification
      const payload = {
        DocumentNumber: userInfo?.DocumentNumber || "", // Using DocumentNumber from userInfo
        Photo: base64Photo,
      };

      const result = await photoUpload(payload, "etd/passport/capture-photo");

      if (result.code == 1 && result.data) {
        if (result?.status === 3) {
          setToken(result?.auth);
          setUserInfo(result.data[0]);
          navigate("/application");
        }
        createNotification({ type: "success", message: "Picha imepakiwa" })();
      } else if (
        result.code == 3 ||
        result.message?.toLowerCase().includes("expire")
      ) {
        createNotification({ type: "error", message: "Session expired" })();
        navigate("/");
      } else {
        const msg = result?.message || "Unexpected error occurred";
        createNotification({ type: "error", message: msg })();
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Network Error. Please try again later.";
      createNotification({ type: "error", message: msg })();
    } finally {
      setIsloading(false);
    }
  };

  // const goToDeclaration = async () => {
  //   setIsloading(true);
  //   const formData = {
  //     ApplicationId: getAppId(),
  //     EmailAddress: getEmail(),
  //     Action: "Normal",
  //   };

  //   try {
  //     const result = await applicationManagementMasilingi(
  //       formData,
  //       "declaration",
  //     );
  //     if (result.code == 1 && result.data) {
  //       setDeclarationInfo(result.data);
  //       navigate("/stp7");
  //     } else if (
  //       result.code == 3 ||
  //       result.message?.toLowerCase().includes("expire")
  //     ) {
  //       createNotification({ type: "error", message: "Session expired" })();
  //       navigate("/");
  //     } else {
  //       const msg = result?.message || "Unexpected error occurred";
  //       createNotification({ type: "error", message: msg })();
  //     }
  //   } catch (error) {
  //     const msg =
  //       error?.response?.data?.message ||
  //       "Network Error. Please try again later.";
  //     createNotification({ type: "error", message: msg })();
  //   } finally {
  //     setIsloading(false);
  //   }
  // };

  // const endeleaBadae = () => {
  //   navigate("/");
  // };

  const backToDocVerification = () => {
    navigate("/docmentVerification");
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link to="#" className="list-group-item active">
                    Upudate Photo{" "}
                  </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <div className="box box-default">
                    <div className="box-header with-border">
                      <h3 className="box-title">Pakia Picha ya Passport</h3>
                    </div>
                    <div className="box-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            style={{
                              border: "1px dashed #999",
                              borderRadius: "4px",
                              padding: "20px",
                              textAlign: "center",
                              backgroundColor: "#ffffff",
                              cursor: "pointer",
                              marginBottom: "15px",
                            }}
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            onClick={() =>
                              document.getElementById("fileInput").click()
                            }
                          >
                            {!previewUrl ? (
                              <>
                                <i
                                  className="fa fa-cloud-upload"
                                  style={{
                                    fontSize: "32px",
                                    color: "#999",
                                    marginBottom: "10px",
                                  }}
                                ></i>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Bonyeza hapa au pakia picha
                                </p>
                                <p style={{ fontSize: "12px", color: "#999" }}>
                                  PNG, JPG au JPEG (Upana: 120-500px, Urefu:
                                  120-500px, Hadi 5MB)
                                </p>
                                <input
                                  id="fileInput"
                                  type="file"
                                  accept=".png,.jpg,.jpeg,image/png,image/jpeg,image/jpg"
                                  onChange={handleFileChange}
                                  style={{ display: "none" }}
                                />
                              </>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "160px",
                                    height: "200px",
                                    border: "2px solid #4CAF50",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                  }}
                                >
                                  <img
                                    src={previewUrl}
                                    alt="Preview"
                                    style={{
                                      width: "160px",
                                      height: "200px",
                                      objectFit: "cover",
                                      display: "block",
                                    }}
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removePhoto();
                                  }}
                                >
                                  <i className="fa fa-times"></i> Ondoa
                                </button>
                                <input
                                  id="fileInput"
                                  type="file"
                                  accept=".png,.jpg,.jpeg,image/png,image/jpeg,image/jpg"
                                  onChange={handleFileChange}
                                  style={{ display: "none" }}
                                />
                              </div>
                            )}
                          </div>
                          {fileError && (
                            <div className="alert alert-danger" role="alert">
                              <i className="fa fa-exclamation-triangle"></i>{" "}
                              {fileError}
                            </div>
                          )}
                          <div className="alert alert-info" role="alert">
                            <i className="fa fa-info-circle"></i>{" "}
                            <strong>Maelekezo:</strong>
                            <ul
                              style={{ marginTop: "10px", marginBottom: "0" }}
                            >
                              <li>
                                Upana wa picha: <strong>120px - 190px</strong> |
                                Urefu: <strong>100px - 200px</strong>
                              </li>
                              <li>
                                <strong>
                                  Mandhari ya picha itabadilishwa kuwa nyeupe
                                  kiotomatiki
                                </strong>
                              </li>
                              <li>
                                Tumia picha ya passport yenye ubora wa juu
                              </li>
                              <li>
                                Tumia Picha yenye background nyeupe, usitumie
                                picha zenye background ya rangi nyingine au
                                picha zenye mandhari magumu
                              </li>
                              <li>Picha iwe wazi na yenye mwanga wa kutosha</li>
                              <li>
                                Usitumie picha iliyochapishwa au picha ya screen
                              </li>
                              <li>Tumia muundo wa PNG, JPG au JPEG tu</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="box-footer">
                    <div className="row">
                      <div className="col-md-4">
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            backToDocVerification();
                          }}
                          className="btn btn-default btn-block btn-label-next"
                        >
                          <i className="fa fa-angle-double-left"></i> | Hatua
                          Iliyotangulia
                        </Link>
                      </div>
                      <div className="col-md-4">
                        <Link
                          className="btn btn-labeled btn-block btn-default"
                          name="SaveExit"
                        >
                          Hifadhi na Toka | <i className="fa fa-save"></i>{" "}
                        </Link>
                      </div>
                      <div className="col-md-4">
                        <button
                          type="submit"
                          className="btn btn-default btn-block btn-label-next"
                          name="SaveNext"
                          value="SaveContinue"
                          onClick={uploadPhoto}
                          disabled={isButtonDisabled || isloading}
                        >
                          {isloading ? "Subiri..." : "Hifadhi na Endelea |"}{" "}
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadPhotoComponent;
